import { Box } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Row = styled(Box)`
  display: flex;
`;

const TextRed = styled(Box)`
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
`;

const TextRedBold = styled(TextRed)`
  font-weight: 600;
  margin-left: 5px;
  margin-right: 5px;
`;

interface IProps {
  amountSurchargeFee: string | number;
  chargeName: string;
}

const HolidaySurcharge = ({ amountSurchargeFee, chargeName }: IProps) => {
  const { t } = useTranslation();
  return (
    <Row>
      <TextRed>
        {t('Please note a holiday surcharge of', {
          chargeName: `${chargeName}`,
          amount: `${amountSurchargeFee}%`,
        })}
      </TextRed>
    </Row>
  );
};

export default HolidaySurcharge;
